export default __webpack_public_path__ + "static/media/rev_f_video_desktop.490dd639.mp4";